import { RELATIVE_DATE_WINDOWS } from '../../billing/components/v2/claims/claimWorkFilters';
import {
  type ClaimWorkUrlState,
  railViewKey,
} from '../../billing/components/v2/claims/claimWorkUrlState';
import { isQueueViewKey } from '../../billing/types/encounterWork';
import type { AdminClaimWorkArgs } from '../types';

export function adminClaimWorkQueryArgs(
  organizationId: string,
  state: ClaimWorkUrlState,
  cursor?: string,
): AdminClaimWorkArgs {
  const selected = (field: string) => {
    const value = state.predicates[field];
    return value?.kind === 'multiSelect' && value.values.length
      ? value.values.join(',')
      : undefined;
  };
  const date = state.predicates.serviceDate;
  const range = date?.kind === 'dateRange' ? date : undefined;
  const window =
    range?.windowDays ?? (range?.preset ? RELATIVE_DATE_WINDOWS[range.preset] : undefined);
  return {
    organizationId,
    workView: state.workView,
    providerIds: selected('provider'),
    payerIds: selected('payer'),
    patientIds: selected('patient'),
    claimLifecycles: selected('claimLifecycle'),
    serviceDateWindowDays: window,
    serviceDateFrom: window ? undefined : (range?.start ?? undefined),
    serviceDateTo: window ? undefined : (range?.end ?? undefined),
    sort: state.sort,
    limit: state.perPage,
    cursor,
    includeHidden: isQueueViewKey(railViewKey(state.workView)) && state.showHidden,
  };
}
